import React, { memo } from 'react';
import { Flex, Form, Grid, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useSearch } from '../hooks/use-search';
import Button from '/react4xp/mixins/ui/button/button';

type SearchBarProps = ReturnType<typeof useSearch>;

const SearchBar = memo(({ isLoading, search, form }: SearchBarProps) => {
    const breakpoint = Grid.useBreakpoint();
    return (
        <Form
            form={form}
            onFinish={search}
            layout="inline"
        >
            <Flex
                style={{ width: '100%' }}
                vertical={!breakpoint.sm}
            >
                <Form.Item
                    style={{ flexGrow: 1 }}
                    noStyle
                    name="query"
                    rules={[{ required: true, message: 'Введите запрос' }]}
                >
                    <Input
                        prefix={<SearchOutlined style={{ color: 'gray' }} />}
                        placeholder="Найти в заголовках статей..."
                    />
                </Form.Item>

                <Form.Item noStyle>
                    <Button
                        htmlType="submit"
                        loading={isLoading}
                        style={{
                            height: 56,
                            width: 150,
                        }}
                    >
                        Искать
                    </Button>
                </Form.Item>
            </Flex>
        </Form>
    );
});

export default SearchBar;
